import React from "react";
import { SearchPrompt } from "../types";

type Props = {
    domain: string;
    niche: string;
    searchPrompts: SearchPrompt[];
}

export default function SearchPromptsList({ domain, niche, searchPrompts }: Props) {
    return (
        <div className="search-prompts-list">
            <div className="section-title">
                <div className="title">Top Questions Asked in LLMs About: {niche}</div>
                <div className="description">These are the most frequently asked questions about your domain's niche.</div>
            </div>
            {searchPrompts && searchPrompts.length && (searchPrompts.map((prompt, index) => (
                <div className="prompt-mention-section" key={index}>
                    <div className="search-prompt">
                        <div className="search-prompt-title"><strong>Top Question #{index + 1}</strong></div>
                        {prompt.query}
                    </div>

                    <div className="answer-container">
                        <div style={{ lineHeight: "24px" }}><strong>LLM answer and cited URLs</strong></div>
                        <div className="answer">{prompt.query_response}</div>
                        <ul className="citations-list">
                            {prompt.results.map((result, index) => (
                                <li key={index} className={`${result.domain === domain ? "highlighted" : ""}`}>
                                    <img
                                        className="favicon"
                                        src={`https://www.google.com/s2/favicons?domain=${result.domain}`}
                                        width="16"
                                        height="16"
                                        alt={`favicon of ${result.domain}`}
                                        onError={(e) => {
                                            e.currentTarget.className = 'default';
                                            if (e.currentTarget.src !== '/images/default_favicon.png') {
                                                e.currentTarget.src = '/images/default_favicon.png';
                                            }
                                        }}
                                    />
                                    <a href={result.url} target="_blank" rel="noopener noreferrer">{result.domain}</a> - <span style={{ fontStyle: "italic" }}>{result.title ? result.title : result.url}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )))}
        </div>
    );
}